import {Api} from 'shared/services';
import {IResultOfAction} from 'shared/services/axios-config/interceptors';

export interface ITokenServico {
  token: string;
  geradoEm: string;
  geradoPor: string;
}

const getTokenServico = async (): Promise<
  IResultOfAction<ITokenServico | null>
> => {
  try {
    const {data} = await Api.get('/ConfigsApisExternas/TokenServico');

    if (!data || !data.Data || !data.Data.Token) {
      const response: IResultOfAction<ITokenServico | null> = {
        data: null,
        success: true,
        message: '',
      };

      return response;
    }

    const tokenServico: ITokenServico = {
      token: data.Data.Token,
      geradoEm: data.Data.GeradoEm,
      geradoPor: data.Data.GeradoPor,
    };

    const response: IResultOfAction<ITokenServico | null> = {
      data: tokenServico,
      success: true,
      message: '',
    };

    return response;
  } catch (error) {
    return error as IResultOfAction<any>;
  }
};

const gerarTokenServico = async (): Promise<
  IResultOfAction<ITokenServico>
> => {
  try {
    const {data} = await Api.post('/ConfigsApisExternas/TokenServico/Gerar');

    const tokenServico: ITokenServico = {
      token: data.Data.Token,
      geradoEm: data.Data.GeradoEm,
      geradoPor: data.Data.GeradoPor,
    };

    const response: IResultOfAction<ITokenServico> = {
      data: tokenServico,
      success: true,
      message: '',
    };

    return response;
  } catch (error) {
    return error as IResultOfAction<any>;
  }
};

export const TokenServicoService = {
  getTokenServico,
  gerarTokenServico,
};
